export type BenchmarkLabelSource = {
    visitDate?: Date | string;
    department?: { name?: string };
    entityType?: string;
    entityName?: string;
    partnerName?: string;
    partner?: { name?: string };
    name?: string;
};

export function getBenchmarkTargetEntityName(
    item: BenchmarkLabelSource
): string {
    if (item.entityType === 'partner') {
        return item.partnerName || item.partner?.name || item.entityName || '';
    }

    return item.entityName || '';
}

export function formatBenchmarkLabel(benchmark: BenchmarkLabelSource): string {
    if (benchmark.name) {
        return benchmark.name;
    }

    const entityName = getBenchmarkTargetEntityName(benchmark);
    const date = benchmark.visitDate
        ? new Date(benchmark.visitDate).toLocaleDateString('en-GB')
        : '';
    const departmentName = benchmark.department?.name || '';

    return [date, departmentName, entityName].filter(Boolean).join(' - ');
}
